import { Box, Typography } from "@mui/material";

export default function LyricsContainer({ currentSong }) {
  // Split the lyrics into an array of lines
  const lines = currentSong.meta.lyrics?.split("\n").map((line, index) => (
    // Render each line in a Typography component, wrapped in a div for proper spacing
    <div key={index}>
      <Typography>{line}</Typography>
    </div>
  ));

  return (
    <>
      {currentSong.meta.lyrics && currentSong.meta.lyrics != "" && (
        <Box
          id="lyrics-container"
          sx={{
            p: 2,
            my: 2,
            background: "#02B2AF",
            maxHeight: "400px",
            overflow: "auto",
            borderRadius: "10px",
            // dont show scrollbar
            "&::-webkit-scrollbar": {
              display: "none",
            },
          }}
        >
          <Typography variant="h6" color="inherit" sx={{ mb: 2 }}>
            Lyrics
          </Typography>
          {lines} {/* Render the array of lines here */}
        </Box>
      )}
    </>
  );
}
